// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessage_message__15zE2","shake":"ErrorMessage_shake__1Izju"};